module.exports = __webpack_public_path__ + "img/ecom-ozon.8bf008e6.png";